import { useStore } from "@stores";
import { useEffect, useState } from "react";

export const useActivePromotions = () => {
  const { promotionStore } = useStore();
  const {
    active,
    activeLoading,
    activeTotalCount,
    activeMaxResultCount,
    activeSkipCount,
  } = promotionStore;

  const [keyword, setKeyword] = useState<string | undefined>(undefined);

  useEffect(() => {
    promotionStore.getActive({
      skipCount: activeSkipCount,
      maxResultCount: activeMaxResultCount,
      keyword,
    });
  }, [promotionStore, activeSkipCount, activeMaxResultCount, keyword]);

  // Reset paging when leaving the page so a return starts on the first page.
  useEffect(() => {
    return () => promotionStore.setActiveSkipCount(0);
  }, [promotionStore]);

  const handleSearch = (value: string) => {
    setKeyword(value || undefined);
    promotionStore.setActiveSkipCount(0);
  };

  return {
    promotions: active,
    loading: activeLoading,
    totalCount: activeTotalCount,
    maxResultCount: activeMaxResultCount,
    currentPage: Math.floor(activeSkipCount / activeMaxResultCount) + 1,
    handlePageChange: promotionStore.handleActivePageChange,
    handleSearch,
  };
};
